import React, { useState } from "react";
import { api, STAGE_LABELS } from "../lib/api";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { toast } from "sonner";
import { Landmark, CheckCircle2 } from "lucide-react";

export function PayoutForm({ win, defaultName, onDone }) {
  const [name, setName] = useState(defaultName || "");
  const [iban, setIban] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/winners/payout-details", { claim_id: win.claim_id, account_name: name, iban });
      toast.success("Bedankt! Je gegevens zijn ontvangen.");
      onDone();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Opslaan mislukt");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="payout-form" className="p-5 rounded-2xl bg-[#12141D] border border-[#00E676]/40 shadow-[0_0_40px_-10px_rgba(0,230,118,0.4)] space-y-3">
      <div className="flex items-center gap-2 text-[#00E676] text-xs uppercase tracking-[0.3em]"><Landmark className="w-4 h-4" /> Uitbetaling</div>
      <div className="font-black text-lg" style={{ fontFamily: "Unbounded, sans-serif" }}>Je hebt €{win.prize} gewonnen!</div>
      <p className="text-sm text-slate-400">{STAGE_LABELS[win.stage]} — vul je rekeninggegevens in, dan maakt de studio het prijzengeld over.</p>
      <div>
        <label className="text-xs uppercase tracking-widest text-slate-400">Naam rekeninghouder</label>
        <Input data-testid="payout-name" value={name} onChange={(e) => setName(e.target.value)} className="mt-1 bg-[#0B0C10] border-white/10 text-white" />
      </div>
      <div>
        <label className="text-xs uppercase tracking-widest text-slate-400">IBAN</label>
        <Input data-testid="payout-iban" value={iban} onChange={(e) => setIban(e.target.value)} placeholder="NL00 BANK 0123 4567 89"
               className="mt-1 bg-[#0B0C10] border-white/10 text-white font-mono uppercase" />
      </div>
      <Button data-testid="payout-submit" onClick={submit} disabled={busy || !iban || name.trim().length < 2}
              className="w-full h-12 bg-[#00E676] text-[#0B0C10] font-black hover:bg-[#00c765]">
        <CheckCircle2 className="w-4 h-4 mr-2" /> {busy ? "Bezig..." : "Verstuur gegevens"}
      </Button>
    </div>
  );
}
